import * as React from "react";
import type { SVGProps } from "react";
const SvgLufthansa = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 50 50"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fill="#0a1d3d"
      d="M33.918 20.427c-.175 0-.322.004-.405.013-.096.175-.239.41-.45.736 3.293 0 6.282.272 9.59.865l-.934.901c-2.985-.529-5.464-.74-8.624-.74-.46 0-.557 0-.667.004-.11.166-.359.488-.607.787.28-.018.823-.028 1.573-.028 2.599 0 5.027.193 7.663.617l-.934.906c-2.006-.313-4.457-.492-6.656-.492-.781 0-1.67.027-2.465.073-.18.207-.648.713-.79.87 1.052-.11 2.211-.162 3.591-.162 1.964 0 3.84.13 5.616.391l-.934.897a36 36 0 0 0-4.157-.248c-3.5 0-6.26.759-9.112 2.502 2.718 2.916 7.17 4.76 11.485 4.76h.405l-1.509 1.459c-6.223-1.169-12.772-3.906-18.305-7.654-5.322-3.592-7.185-4.655-11.338-6.49l-.028-1.067 2.81 1.205.957-.759 9.176 4.204-.598.478-4.71-2.046-.464.363 2.447 1.366c2.065 1.15 3.638 1.665 5.091 1.665 3.178 0 6.03-2.254 7.87-6.214 1.384-.179 2.86-.262 4.636-.262 3.643 0 7.18.35 11.186 1.1l-.975.942c-2.493-.52-6.73-.943-9.434-.943M25 46.62C13.063 46.62 3.38 36.937 3.38 25S13.063 3.38 25 3.38 46.62 13.063 46.62 25 36.937 46.62 25 46.62M25 2C12.281 2 2 12.281 2 25s10.281 23 23 23 23-10.281 23-23S37.719 2 25 2"
    />
  </svg>
);
export default SvgLufthansa;
